import React from 'react';

const Card = ({ title, content, isEditable, onClick, className, backgroundImage, subTitle }) => {
    return (
        <div
            className={`dashboard-card ${className} ${isEditable ? 'editable' : ''}`}
            onClick={isEditable ? onClick : null}
            style={{
                backgroundImage: `url(${backgroundImage})`, // Apply background image
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }}
        >
            <h3 className='dashboard-card-title card-title'>{title}</h3>
            <h5 style={{color: 'red'}} className='dashboard-card-title'>{subTitle}</h5>
            <p>{content}</p>
        </div>
    );
};

export default Card;
